
export const initialDefaultValues = {
  internal_name: "",
  external_name: "",
  description: "",
  items: [],
  delete_items: [],
  plan_exists_subscriptions: false
};
